import { FC, useState } from "react";

import { CampaignBody } from "@vviinn/user-managment-client-ts";

import { arePrimitiveArraysEqual } from "../../../helpers";
import { VpdAttributesWrapper } from "../../components";
import { AcceptableNamedRow } from "../../../ui/layout/organisms/SlideOver/SlideOverFixedLayouts/AcceptableNamedRow";
import { CollapsedFields } from "../../../components/GeneralUI/CollapsedFields/CollapsedFields";
import { UpdateCampaignProps } from "../types";

type PredictableAttributesAcceptableRowProps = UpdateCampaignProps & {
  config?: CampaignBody;
};

export const PredictableAttributesAcceptableRow: FC<
  React.PropsWithChildren<PredictableAttributesAcceptableRowProps>
> = ({ updateCampaignBody, campaign }) => {
  const initialProductAttributes = campaign.productAttributes ?? [];
  const initialImageAttributes = campaign.imageAttributes ?? [];

  const activatedAttributesCount =
    initialProductAttributes.length + initialImageAttributes.length;

  const [productAttributes, setProductAttributes] = useState<string[]>(
    initialProductAttributes,
  );
  const [imageAttributes, setImageAttributes] = useState<string[]>(
    initialImageAttributes,
  );

  const initAttributes = () => {
    setProductAttributes(initialProductAttributes);
    setImageAttributes(initialImageAttributes);
  };

  const resetAttributes = () => {
    setProductAttributes([]);
    setImageAttributes([]);
  };

  const areSettingsChanged =
    !arePrimitiveArraysEqual(productAttributes, initialProductAttributes) ||
    !arePrimitiveArraysEqual(imageAttributes, initialImageAttributes);

  const handleAccept = async () =>
    await updateCampaignBody(
      {
        productAttributes,
        imageAttributes,
      },
      "attribute prediction",
    );

  return (
    <AcceptableNamedRow
      title="Attribute Prediction"
      onSubmit={handleAccept}
      allowSubmit={areSettingsChanged}
      initConfig={initAttributes}
      permissionsGroup="campaign:basic_config"
      content={activatedAttributesCount}
    >
      <CollapsedFields
        active={!!activatedAttributesCount}
        title="Activate Attribute Prediction"
        resetFields={resetAttributes}
        activateFields={initAttributes}
      >
        <VpdAttributesWrapper
          productAttributes={productAttributes}
          setProductAttributes={setProductAttributes}
          imageAttributes={imageAttributes}
          setImageAttributes={setImageAttributes}
        />
      </CollapsedFields>
    </AcceptableNamedRow>
  );
};
